<template>

  <div>
    <div style="width: 100%;">
      <img src="./banner5.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative;text-align: center">

      <img src="./map.png" style="width: 60%; height: auto;">
      <div class="experience-section">
        <h2>请专业顾问为您解答或演示</h2>
        <p>留下您的姓名和联系方式，会有专业人员免费为您服务</p>
        <el-button class="experience-button" @click="showDialog = true">立即体验</el-button>
      </div>
    </div>
    <!-- 引入弹窗组件 -->
    <call-me-dialog v-if="showDialog" :visible.sync="showDialog" />
  </div>


</template>
<style scoped>
@import 'callMe.css';
</style>
<script>
import CallMeDialog from '../../components/CallMeDialog.vue'

export default {
  components: {CallMeDialog},
  data() {
    return {
      showDialog: false
    }
  },

  methods: {
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/callMe/callMe.vue